import { useEffect, useState } from 'react';
import { useSession } from '@/contexts/LitSessionProvider';
import useERC20Balance, { IUserERC20Balance } from '@/hooks/portfolio/useERC20Balance';
import Loading from '@/components/shared/Loading';
import { ResolutionData, resolutionData } from '@/lib/tradingview/chartData';
import { CurrentPrice } from '@/components/charts/PortfolioChart';
import { UTCTimestamp } from 'lightweight-charts';
import DTPorfolioChart from '@/components/charts/desktop/DTPorfolioChart';
import ChartPriceHeader from './ChartPriceHeader';
import DTPortfolioAssets from './DTPortfolioAssets';
const TotalPortfolioLink = ({
  assetData,
  currentPrice,
  currentResolution
}: {
  assetData: IUserERC20Balance;
  currentPrice: CurrentPrice;
  currentResolution: ResolutionData;
}) => {
  return <div className='flex items-center w-full justify-start' data-sentry-component="TotalPortfolioLink" data-sentry-source-file="index.tsx">
      <ChartPriceHeader currentResolution={currentResolution} currentPrice={currentPrice} assetData={assetData} data-sentry-element="ChartPriceHeader" data-sentry-source-file="index.tsx" />
    </div>;
};
export default function DesktopPorfolioPage() {
  const {
    PKP
  } = useSession();
  const {
    data: assetData,
    isLoading: isLoadingAssetData
  } = useERC20Balance({
    evmAddresses: [PKP?.additionalEthAddress],
    solanaAddresses: [PKP?.solanaAddress],
    useGeniusAPI: true
  });
  const [chartPrice, setChartPrice] = useState(0);
  const [currentPrice, setCurrentPrice] = useState<CurrentPrice>(null);
  const [showPrice, setShowPrice] = useState(true);
  const [currentResolution, setCurrentResolution] = useState(resolutionData[0]);
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  const handleChangeChart = (value: number, beforeValue: number, timestamp: UTCTimestamp) => {
    setChartPrice(value);
    setCurrentPrice({
      value: value,
      before: beforeValue,
      time: timestamp
    });
  };
  if (!isClient) {
    return;
  }
  return <div data-sentry-component="DesktopPorfolioPage" data-sentry-source-file="index.tsx">
      <div className='rounded-[20px] border-genius-blue border-[1px] bg-genius-indigo genius-shadow overflow-hidden'>
        <div className='flex items-center rounded-lg mb-4 '>
          <TotalPortfolioLink currentPrice={currentPrice} currentResolution={currentResolution} assetData={assetData} data-sentry-element="TotalPortfolioLink" data-sentry-source-file="index.tsx" />
        </div>
        <div className='w-full'>
          <DTPorfolioChart onValueChange={handleChangeChart} setCurrentPrice={setCurrentPrice} setShowPrice={setShowPrice} currentResolution={currentResolution} setCurrentResolution={setCurrentResolution} assetData={assetData} data-sentry-element="DTPorfolioChart" data-sentry-source-file="index.tsx" />
        </div>
      </div>
      <div className='mt-4 overflow-auto h-[50vh] no-scrollbar rounded-b-[20px] border-genius-blue border-b-[2px] bg-genius-indigo genius-shadow'>
        <DTPortfolioAssets isSwap={false} showBreakDown={true} data-sentry-element="DTPortfolioAssets" data-sentry-source-file="index.tsx" />
      </div>
    </div>;
}